import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1cd1501f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1cd1501f&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd1501f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cd1501f')) {
      api.createRecord('1cd1501f', component.options)
    } else {
      api.reload('1cd1501f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1cd1501f&scoped=true", function () {
      api.rerender('1cd1501f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modulestore/module/7-2-pop-bar-2/index.vue"
export default component.exports